import {isStringEnum} from './isStringEnum';

export function isStringEnumValue<T extends object>(enumValue?: any, enumObject?: T): enumValue is T {
    return typeof enumValue === 'string'
        && !!enumObject
        && isStringEnum<T>(enumObject)
        && Object.values(enumObject).includes(enumValue);
}
